import { Injectable } from '@angular/core';
import { BaseService as __BaseService } from '../base-service';
import { ApiConfiguration as __Configuration } from '../api-configuration';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { FinanceDTO, FinanceFilters } from '../models/finance.models';

@Injectable({
  providedIn: 'root'
})
export class FinanceService extends __BaseService {

  private readonly financePath = `${this.rootUrl}/Finance`;

  constructor(
    config: __Configuration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * [GET] /api/bo/Finance/filters/{idEvent}
   * Get the filters for the finance section
  */
  getFinanceFilters(idEvent: number): Observable<any> {
    const url = `${this.financePath}/filters/${idEvent}`;
    return this.http.get<FinanceFilters>(url);
  }

  /**
   * [GET] /api/bo/Finance/appointments/{idEvent}
   * Get the finance list of appointments grouped by date
  */
  getFinanceData(idEvent: number, payload?: any): Observable<FinanceDTO[]> {
    const url = `${this.financePath}/appointments/${idEvent}`;
    let params = this.newParams();
    if (payload) {
      let { FullText, Countries, Data } = payload;
      if (FullText) {
        params = params.set('FullText', FullText);
      }
      if (Countries && Countries.length > 0) {
        Countries.forEach((country: any) => {
          params = params.append('Countries', country)
        });
      }
      if (Data) {
        params = params.set('Data', Data);
      }
    }
    return this.http.get<FinanceDTO[]>(url, { params });
  }

  /**
   * [GET] /api/bo/Finance/download/{idEvent}
   * Get sas uri of Digital form for appointment
  */
  export(idEvent: number, payload: any): Observable<any> {
    const url = `${this.financePath}/download/${idEvent}`;
    let params = this.newParams();
    if (payload.idAppointment) params = params.set('idAppointment', payload.idAppointment);
    if (payload.clientName) params = params.set('clientName', payload.clientName);
    return this.http.get<any>(url, { params, responseType: 'text' as "json" });
  }

  /**
   * [GET] api/bo/Finance/export/{idEvent}
   * Export della sezione Finance
   */
  fullExport(idEvent: number) {
    const url = `${this.financePath}/export/${idEvent}`;
    return this.http.get<any>(url, { responseType: "blob" as "json" });
  }

}
